import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { getInitialRoute, getTimeTypeSecondToTime } from '../../../../../../../../../utils'
import { updateNoticeBoard } from "../../../../../../../../../actions/sceneActions";
import { CloudUrlStudio} from "../../../../../../../../../actions/api";
import { FontAwesomeIcon } from "../../../../../../../../CommonComponents/AssetsHelper";

class MotivationalQuote extends Component {
  onClickToEdit = (event) => {
    const { item } = this.props;
    this.props.updateNoticeBoard(item, this.onNavigateToUpdateView);
  };
  onNavigateToUpdateView = () => {
    const { item, history, match, sceneID } = this.props;
    history(
      `/studio/${match.params.wallId}/update/apps/${sceneID}/${item.position}/${item.id}/${item.app_id}`
    );
  };
  render() {
    const {
      item,
      onDelete,
      onIncreaseUpdateDuration,
      onDeCreaseUpdateDuration,
      onMouseOutUpdateDuration,
    } = this.props;

    return (
      
      <div className="card-header scene-header">
        <Row>
          <Col col={5}>
            <div className="d-flex align-items-center justify-content-start h-100">
              <div className="mx-4">
                <img
                  src={`${CloudUrlStudio}/app_icons/Quotes.svg`}
                  style={{ width: 40, height: "auto" }}
                />
              </div>
              <h6 className="wall-text mb-0">{item.name}</h6>
            </div>
          </Col>

          <Col col={2} className="align-items-center d-flex justify-content-center">
            <div className="d-flex form-control form-control-sm align-items-center d-flex justify-content-center w-auto">
              <div className="timer_setting sc-eggNIi ezaVln d-flex align-items-center justify-content-center flex-column position-relative overflow-hidden" value="60000" onMouseLeave={onMouseOutUpdateDuration(item.id, item.sceneDuration)}>
                <button className="btn p-0 btn-icon btn-xs button sc-jrAGrp hdBNDM sc-kEjbxe bLcVSM increase-btn" tabindex="-1" onClick={onIncreaseUpdateDuration(item.id, item.sceneDuration, 1)}>
                  <i className="fa fa-caret-up m-0 p-0" aria-hidden="true"></i>
                </button>
                <input type="text" className="input form-control form-control-sm border-0" value={getTimeTypeSecondToTime(item.sceneDuration, 1)} />
                <button className="btn p-0 btn-icon btn-xs button sc-jrAGrp hdBNDM sc-kEjbxe bLcVSM decrease-btn" tabindex="-1" onClick={onDeCreaseUpdateDuration(item.id, item.sceneDuration, 1)}>
                  <i className="fa fa-caret-down m-0 p-0" aria-hidden="true"></i>
                </button>
              </div>
              <span>:</span>
              <div className="timer_setting sc-eggNIi ezaVln d-flex align-items-center justify-content-center flex-column position-relative" value="60000" onMouseLeave={onMouseOutUpdateDuration(item.id, item.sceneDuration)}>
                <button className="btn p-0 btn-icon btn-xs button sc-jrAGrp hdBNDM sc-kEjbxe bLcVSM increase-btn" tabindex="-1" onClick={onIncreaseUpdateDuration(item.id, item.sceneDuration, 2)}>
                  <i className="fa fa-caret-up m-0 p-0" aria-hidden="true"></i>
                </button>
                <input type="text" className="input form-control form-control-sm border-0" value={getTimeTypeSecondToTime(item.sceneDuration, 2)} />
                <button className="btn p-0 btn-icon btn-xs button sc-jrAGrp hdBNDM sc-kEjbxe bLcVSM decrease-btn" tabindex="-1" onClick={onDeCreaseUpdateDuration(item.id, item.sceneDuration, 2)}>
                  <i className="fa fa-caret-down m-0 p-0" aria-hidden="true"></i>
                </button>
              </div>
              <span>:</span>
              <div className="timer_setting sc-eggNIi ezaVln d-flex align-items-center justify-content-center flex-column position-relative" value="60000" onMouseLeave={onMouseOutUpdateDuration(item.id, item.sceneDuration)}>
                <button className="btn p-0 btn-icon btn-xs button sc-jrAGrp hdBNDM sc-kEjbxe bLcVSM increase-btn" tabindex="-1" onClick={onIncreaseUpdateDuration(item.id, item.sceneDuration, 3)}>
                  <i className="fa fa-caret-up m-0 p-0" aria-hidden="true"></i>
                </button>
                <input type="text" className="input form-control form-control-sm border-0" value={getTimeTypeSecondToTime(item.sceneDuration, 3)} />
                <button className="btn p-0 btn-icon btn-xs button sc-jrAGrp hdBNDM sc-kEjbxe bLcVSM decrease-btn" tabindex="-1" onClick={onDeCreaseUpdateDuration(item.id, item.sceneDuration, 3)}>
                  <i className="fa fa-caret-down m-0 p-0" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </Col>

          <Col col={5}>
            <div className="d-flex align-items-center justify-content-between h-100">
              <div className="flex-grow-1">
                <p className="text-center mb-0 text-muted">{item.name}</p>
              </div>

              <div className="flex-shrink-0">
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-clean btn-icon btn-sm me-2"
                    onClick={this.onClickToEdit}
                  >
                    <FontAwesomeIcon type={'regular'} icon={'pen-to-square'} iconClass={''} />
                  </button>
                  <button
                    type="button"
                    className="btn btn-clean btn-icon btn-sm me-2"
                    onClick={onDelete(item.id)}
                  >
                    <FontAwesomeIcon type={'regular'} icon={'trash-can'} iconClass={''} />
                  </button>
                  <button
                    type="button"
                    className="btn border-start btn-lg cursor-all-scroll"
                  >
                    <FontAwesomeIcon type={'regular'} icon={'arrows-up-down-left-right'} iconClass={''} />
                  </button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    scenes: state.scene,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateNoticeBoard: (item, callBack) => dispatch(updateNoticeBoard(item, callBack)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MotivationalQuote);
